import { useQuery } from "@tanstack/react-query";
import type { ProductLotDto, ProductStockHistoryDto } from "@hisense/shared";
import { apiFetch } from "@/lib/api";

/** Lịch sử điều chỉnh tay có từ trước 18/09/2026 — chỉ đọc. */
export function useProductStockHistory(productId: string) {
  return useQuery({
    queryKey: ["product-stock", productId],
    queryFn: async ({ signal }) => (await apiFetch<{ data: ProductStockHistoryDto }>(
      `/products/${productId}/stock-adjustments`, { signal },
    )).data,
  });
}

/** Các lô của sản phẩm trong Kho & LOT — nguồn tồn duy nhất. */
export function useProductLots(productId: string) {
  return useQuery({
    queryKey: ["product-lots", productId],
    queryFn: async ({ signal }) => (await apiFetch<{ data: ProductLotDto[] }>(`/products/${productId}/lots`, { signal })).data,
  });
}
